import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/providers/config/config.service';
import { SharedDataService } from 'src/providers/shared-data/shared-data.service';
import { ModalController, NavController } from '@ionic/angular';
import { LoadingService } from 'src/providers/loading/loading.service';
import { AppEventsService } from 'src/providers/app-events/app-events.service';
import { GeolocationPage } from '../modals/geolocation/geolocation.page';
import { Geolocation, GeolocationOptions, Geoposition, PositionError } from '@ionic-native/geolocation/ngx';
import { GoogleMapComponent } from 'src/components/google-maps/google-maps.component';

declare var google;

interface Marker {
  position: {
    lat: number,
    lng: number,
  };
  title: string;
}
@Component({
  selector: 'branch-office',
  templateUrl: './branch-office.page.html',
  styleUrls: ['./branch-office.page.scss'],
})
export class BranchOfficePage implements OnInit {

  @ViewChild(GoogleMapComponent, { static: false }) mapComp: GoogleMapComponent;

  mapSuc = null;
  private myLatLng;
  private Marker;
  private markers = Array();
  private options: GeolocationOptions;


  constructor(
    public navCtrl: NavController,
    public shared: SharedDataService,
    public modalCtrl: ModalController,
    public config: ConfigService,
    public appEventsService: AppEventsService,
    public loading: LoadingService,
    private geolocation: Geolocation,
    private mdCtrl: ModalController) {

  }
  ngOnInit() {

    // this.getPosition();
   // this.addMarker();
  }


  dismiss() {
    this.shared.currentOpenedModel = null;
    this.mdCtrl.dismiss();
  }

  getPosition(): void {

    this.geolocation.getCurrentPosition(this.options).then((pos: Geoposition) => {

      this.myLatLng = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      this.loadMap();

    }, (err: PositionError) => {
      console.log("error : " + err.message);
      let branch = this.shared.allBranchOffice[0];
      this.myLatLng = { lat: parseFloat(branch.latitud), lng: parseFloat(branch.longitud) };
      this.loadMap();

    });
  }


  loadMap() {
    // create a new map by passing HTMLElement
    const mapEle: HTMLElement = document.getElementById('map');
    // create map
    this.mapSuc = new google.maps.Map(mapEle, {
      center: this.myLatLng,
      zoom: 11
    });

    google.maps.event.addListenerOnce(this.mapSuc, 'idle', () => {
      mapEle.classList.add('show-map');

      this.shared.allBranchOffice.forEach(branch => {

        this.myLatLng = { lat: parseFloat(branch.latitud), lng: parseFloat(branch.longitud) };

        this.Marker = new google.maps.Marker({
          position: {
            lat: this.myLatLng.lat,
            lng: this.myLatLng.lng
          },
          map: this.mapSuc,
          draggable: false,
          title: branch.nombre + ' ' + branch.direccion
        });

        //this.Marker.setIcon("ruta de la imagen");
        let content = '<div style="display:block;margin:auto"> <h2 style="text-align:center;color: #3980ff">' + branch.nombre + '</h2></div>' +
          '<div style="display:block;margin:auto"><img src="' + this.config.imgUrl + branch.foto + '" style="width:200px;height:100px;display:block;margin:auto"></div>' +
          '<div style="display:block;margin:auto"><p style="text-align:center"> ' + branch.direccion + '</p></div>' +
  
          '<div style="display:block;margin:auto"><p style="text-align:center"> Telefono: ' + branch.telefono + '</p></div>';

        this.addInfoWindow(this.Marker, content);
        this.markers.push(this.Marker);

      });

    });

    // this.autoCenter();
  }


  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.mapSuc, marker);
    });
  }

  async verMapa(branch) {
    console.log(branch);
    let modal = await this.modalCtrl.create({
      component: GeolocationPage,
      componentProps: { latitude: branch.latitud, longitude: branch.longitud, name: branch.nombre, address: branch.direccion }
    });
    return await modal.present();
  }

  addMarker() {
    this.shared.allBranchOffice.forEach(branch => {
      //this.Marker.setIcon("ruta de la imagen");
      let content = '<div style="display:block;margin:auto"> <h2 style="text-align:center;color: #3980ff">' + branch.nombre + '</h2></div>' +
        '<div style="display:block;margin:auto"><img src="' + this.config.imgUrl + branch.foto + '" style="width:200px;height:100px;display:block;margin:auto"></div>' +
        '<div style="display:block;margin:auto"><p style="text-align:center"> ' + branch.direccion + '</p></div>' +
        '<div style="display:block;margin:auto"><p style="text-align:center"> ' + branch.ciudad + '</p></div>' +
        '<div style="display:block;margin:auto"><p style="text-align:center"> Telefono: ' + branch.telefono + '</p></div>';
      this.mapComp.addMarker_infoWin(parseFloat(branch.latitud), parseFloat(branch.longitud), branch.nombre + ' ' + branch.direccion, content);
    });

    this.mapComp.autoCenter();

  }
}
